import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';

const TileSkeleton = () => {
	const { t } = useGlobalLocale();

	return (
		<div>
			<GovSkeleton
				width="40%"
				height="27px"
				aria-label={t('loading.wcag.processing')}
			/>
			<div className="flex flex-row gap-2">
				<GovSkeleton
					width="20%"
					height="19px"
					aria-label={t('loading.wcag.processing')}
				/>
				<GovSkeleton
					width="20%"
					height="19px"
					aria-label={t('loading.wcag.processing')}
				/>
			</div>
		</div>
	);
};

export const ProfileRezaViewSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<ContentLayout>
			<LayoutGap gap="xl">
				<div className="flex gap-4">
					<GovSkeleton
						width="120px"
						height="40px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="85px"
						height="40px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="130px"
						height="40px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="110px"
						height="40px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="90px"
						height="40px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>

				<GovSkeleton
					width="50%"
					height="30px"
					aria-label={t('loading.wcag.processing')}
				/>
				<LayoutGap>
					{[...Array(3)].map((_, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<TileSkeleton key={index} />
					))}
				</LayoutGap>

				<GovSkeleton
					width="50%"
					height="30px"
					aria-label={t('loading.wcag.processing')}
				/>
				<LayoutGap>
					{[...Array(3)].map((_, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<TileSkeleton key={index} />
					))}
				</LayoutGap>
			</LayoutGap>
		</ContentLayout>
	);
};
